/**
 * Copyright (C) 2024 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */

import {SiteOverview} from "./cmk_site_overview";

export class AlertOverview extends SiteOverview {
    override ident() {
        return "alert_overview";
    }
}
